import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const ServerCommunicationUtil = {
  apiKey: '3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i',
  defaultAuthHeaders() {
    return {
      'X-AT-KEY': ServerCommunicationUtil.apiKey,
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content
    };
  },
  getApiEndpoint(
    url,
    params,
    successCallback,
    errorCallback,
    completeCallback,
    headerOptions = {},
    dataType = null // do not override in default case
  ) {
    const paramsHash = {
      headers: { ...this.defaultAuthHeaders(), ...headerOptions },
      type: 'GET',
      url,
      data: params,
      success(data, status, xhr) {
        successCallback(data, status, xhr);
      },
      error(xhr, status, errorString) {
        errorCallback(xhr, status, errorString);
      },
      complete(xhr, status) {
        completeCallback(xhr, status);
      }
    };

    if (dataType) {
      paramsHash.dataType = dataType;
    }
    return $.ajax(paramsHash);
  },
  loadMoreContent(
    category,
    countryId,
    locationType,
    locationId,
    page,
    perPage,
    includeTrail,
    attribute,
    completeCallback,
    onlyWithParks = false,
    sortOption,
    parkType,
    locale
  ) {
    let url;
    let params;
    if (locationType === 'trails') {
      // naming inconsistency between maps and tracks on front end vs API
      const apiCategory = category === 'tracks' ? 'maps' : category;
      url = `/api/alltrails/v2/${locationType}/${locationId}/${apiCategory}`;
    } else if (locationType === 'users') {
      url = `/api/alltrails/users/${locationId}/${category}`;
    } else if (locationType === 'lists') {
      url = `/api/alltrails/v2/lists/${locationId}/${category}`;
    } else {
      url = `/api/alltrails/locations/${locationType}/${locationId}/${category}`;
    }

    if (category === 'tracks' || category === 'maps') {
      params = {
        page,
        per_page: perPage,
        detail: 'shallow',
        presentation_type: 'track'
      };
      if (sortOption) params.sort_option = sortOption;
    } else if (category === 'reviews') {
      params = {
        page,
        per_page: perPage
      };
      if (sortOption) params.sort_option = sortOption;
    } else if (category === 'photos') {
      params = {
        page,
        per_page: perPage
      };
      if (sortOption) params.sort_option = sortOption;
    } else if (category === 'trails' || category === 'nearby_trails') {
      params = {
        page,
        per_page: perPage,
        algolia_formatted: true
      };
    } else if (category === 'items') {
      params = {
        page,
        per_page: perPage,
        include_obj: true
      };
    } else if (category === 'completed') {
      params = {
        page,
        per_page: perPage,
        include_obj: true
      };
    }

    // include country code to narrow down cities and states
    if (locationType === 'cities' || locationType === 'states') {
      params.country_id = countryId;
    }

    if (attribute) {
      params.attribute = attribute;
    }

    if (onlyWithParks) {
      params.only_with_parks = true;
    }
    if (parkType) {
      params.park_type = parkType;
    }

    let additionalHeaders = {};
    // provide language header for translation if it is present
    if (locale) {
      additionalHeaders = { 'X-Language-Locale': locale };
    }

    this.getApiEndpoint(
      url,
      params,
      data => {
        completeCallback(data);
      },
      () => {},
      () => {},
      additionalHeaders
    );
  },
  putApiEndpoint(url, params, successCallback, errorCallback, completeCallback, headerOptions = {}, dataType = null) {
    const paramsHash = {
      headers: { ...this.defaultAuthHeaders(), ...headerOptions },
      type: 'PUT',
      url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(params),
      success(data, status, xhr) {
        successCallback(data, status, xhr);
      },
      error(xhr, status, errorString) {
        errorCallback(xhr, status, errorString);
      },
      complete(xhr, status) {
        completeCallback(xhr, status);
      }
    };

    if (dataType) {
      paramsHash.dataType = dataType;
    }
    return $.ajax(paramsHash);
  },
  postApiEndpoint(url, params, successCallback, errorCallback, completeCallback, headerOptions = {}) {
    return $.ajax({
      headers: { ...this.defaultAuthHeaders(), ...headerOptions },
      type: 'POST',
      url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(params),
      success(data, status, xhr) {
        successCallback(data, status, xhr);
      },
      error(xhr, status, errorString) {
        errorCallback(xhr, status, errorString);
      },
      complete(xhr, status) {
        completeCallback(xhr, status);
      }
    });
  },
  deleteApiEndpoint(url, params, successCallback, errorCallback, completeCallback) {
    $.ajax({
      headers: { ...this.defaultAuthHeaders() },
      type: 'DELETE',
      url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(params),
      success(data, status, xhr) {
        successCallback(data, status, xhr);
      },
      error(xhr, status, errorString) {
        errorCallback(xhr, status, errorString);
      },
      complete(xhr, status) {
        completeCallback(xhr, status);
      }
    });
  },
  initGoogle(successCallback) {
    if (window && window.gapi) {
      window.gapi.load('auth2', () => {
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        window.gapi.auth2
          .init({
            client_id: '127587500781-rjpk7g3rhiobeeqq33fis0a35olspsi0.apps.googleusercontent.com',
            cookiepolicy: 'single_host_origin',
            scope: 'profile email'
          })
          .then(currentGoogleAuth => {
            currentGoogleAuth.signOut();
            const googleButtons = document.getElementsByClassName('google');
            for (let i = 0; i < googleButtons.length; i++) {
              currentGoogleAuth.attachClickHandler(googleButtons[i], {}, successCallback, error => {
                console.error(JSON.stringify(error, undefined, 2));
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      });
    }
  },
  initApple(authState) {
    const appleButtons = document.getElementsByClassName('apple');
    const redirectURI = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${
      StringConstantsMixin.constants.APPLE_SIWA.REDIRECT_PATH
    }`;
    const auth_url = `${StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_URL +
      StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_PARAMS}&client_id=${
      StringConstantsMixin.constants.APPLE_SIWA.CLIENT_ID
    }&redirect_uri=${encodeURIComponent(redirectURI)}&scope=${encodeURIComponent(StringConstantsMixin.constants.APPLE_SIWA.SCOPES)}&auth_state=${authState}`;
    const handleAppleClick = function() {
      window.location = auth_url;
    };
    for (let i = 0; i < appleButtons.length; i++) {
      appleButtons[i].onclick = handleAppleClick;
    }
  },
  usersPath(user) {
    return `/members/${user.slug}`;
  },
  signupPath(ref) {
    if (ref) return `/signup?ref=${ref}`;
    return '/signup';
  },
  handleGaqPush(gaqArray) {
    _gaq.push(gaqArray);
  }
};

export { ServerCommunicationUtil };
